<div
  class="grid grid-rows-[minmax(0,auto)_minmax(0,1fr)] border-0 border-l border-solid border-gray-200 isolate"
  [style.height]="'calc(100svh - var(--res-header-cloudmed-height))'"
>
  <!-- Expand/Collapse -->
  <div
    [attr.data-expanded]="expanded()"
    class="bg-white px-2 py-2 transition-all [&[data-expanded=true]>button]:rotate-180"
  >
    <button
      class="inline-block duration-200"
      (click)="togglePanel()"
    >
      <i class="r1-icon r1-icon-chevron-left-light"></i>
    </button>
  </div>
  <div class="overflow-y-auto">
    <div
      class="expanded-panel h-full transition-[display,opacity] duration-300 [transition-behavior:allow-discrete]"
      [class.hidden]="!expanded()"
      [class.opacity-0]="!expanded()"
      [class.opacity-100]="expanded()"
    >
      <mat-accordion [multi]="true">
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header class="sticky top-0 z-auto">
            <mat-panel-title>
              Issue Category: {{ summary()?.issueCategory }}
            </mat-panel-title>
          </mat-expansion-panel-header>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header class="sticky top-0 z-auto">
            <mat-panel-title>
              Opportunity Details
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p class="p-2">
            {{ (summary()?.opportunitySummary ?? '') | htmlToPlainText }}
          </p>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header class="sticky top-0 z-auto">
            <mat-panel-title>
              AI Generated Summary
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p class="p-2">{{ (summary()?.llmNoteSummary ?? '') | htmlToPlainText }}</p>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header class="sticky top-0 z-auto">
            <mat-panel-title>
              Facility Info
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            @for(address of summary()?.facilityAddresses; track address) {
              <div class="p-2 pl-8">
                <h2 class="text-section-header m-0">
                  <i class="pi pi-map-marker pr-2"></i>{{ address.addressType }}
                </h2>
                <ri-resolution-ui-mailing-address
                  [address]="address"
                  [copyButtonMode]="CopyButtonMode.OnAlways"
                ></ri-resolution-ui-mailing-address>
              </div>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
  <div
    [class.hidden]="expanded()"
    class="w-12 transition-[display] duration-300 [transition-behavior:allow-discrete]"
  ></div>
</div>
